import { createApp } from 'vue';
import App from './App.vue';
import router from './router/routes';
import store from './store/index';
import i18n from './i18n';
import mitt from 'mitt'
import CKEditor from '@ckeditor/ckeditor5-vue';
import VueTippy from 'vue-tippy';
import * as Sentry from "@sentry/vue";

window.translate = require('../VueTranslation/Translation').default.translate;

const app = createApp(App)

app.config.globalProperties.translate = require('../VueTranslation/Translation').default.translate;
app.config.globalProperties.emitter = mitt()

if (process.env.MIX_APP_ENV === 'production') {
    Sentry.init({
        app,
        dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
        integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        ],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        beforeSend(event, hint) {
        const error = hint?.originalException;

        if (error && error.isAxiosError) {
            return null;
        }

        return event;
        }
    });
}

app.use(router)
app.use(CKEditor)
app.use(store)
app.use(i18n)
app.use(VueTippy, {
    directive: 'tippy',
    component: 'tippy',
    componentSingleton: 'tippy-singleton',
    defaultProps: {
        placement: 'auto-end',
        allowHTML: true,
    },
})
app.mount('#app');
